import { ErrorDisclaimer } from "@components/ErrorDisclaimer";
import { Spacing, SpacingSizes } from "@components/Spacing";
import { i18n, Translations } from "@i18n";
import { WithdrawalReasonCode, WithdrawalStatusBannerProps } from "@routes/WithdrawRoute/types";

const REASON_CODE_TO_TRANSLATION: Record<WithdrawalReasonCode | string, string> = {
  [WithdrawalReasonCode.GoalNotFound]: i18n.t(Translations.WithdrawalStatusBannerGoalNotFound),
  [WithdrawalReasonCode.UserNotActive]: i18n.t(Translations.WithdrawalStatusBannerUserNotActive),
  [WithdrawalReasonCode.AccountNotFound]: i18n.t(
    Translations.WithdrawalStatusBannerAccountNotFound,
  ),
  [WithdrawalReasonCode.AccountNotActive]: i18n.t(
    Translations.WithdrawalStatusBannerAccountNotActive,
  ),
  [WithdrawalReasonCode.CompletedWithdrawalToday]: i18n.t(
    Translations.WithdrawalStatusBannerCompletedWithdrawalToday,
  ),
  [WithdrawalReasonCode.ProcessingWithdrawalExists]: i18n.t(
    Translations.WithdrawalStatusBannerProcessingWithdrawalExists,
  ),
};

export const WithdrawalStatusBanner = ({ reasonCode }: WithdrawalStatusBannerProps) => {
  const message =
    REASON_CODE_TO_TRANSLATION[reasonCode] ?? i18n.t(Translations.WithdrawalStatusBannerDefault);

  return (
    <>
      <ErrorDisclaimer message={message} />
      <Spacing size={SpacingSizes.M} />
    </>
  );
};
